import { CircularProgress, Stack, SxProps } from "@mui/material";
import { styled } from "@mui/material/styles";

type CenteredLoadingProps = {
  sx?: SxProps;
};

export default function CenteredLoading({ sx }: CenteredLoadingProps) {
  return (
    <Wrapper sx={sx}>
      <CircularProgress />
    </Wrapper>
  );
}

const Wrapper = styled(Stack)(({ theme }) => ({
  justifyContent: "center",
  alignItems: "center",
  minHeight: `calc(100vh - ${theme.variables.topBarHeight}px)`,
}));
